











































import { PopRoute, AddRoute, ReplaceRoute } from '../../types/store';
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Action, Mutation, State} from "vuex-class";
import AdminPageInfo from './AdminPageInfo.vue';
import AdminCard from './AdminCard.vue';
import btn from './btn.vue';
import Label from './Label.vue';

@Component({
    components: {
        AdminPageInfo,
        AdminCard,
        btn,
        Label,
    },
})
export default class BookingComplete extends Vue {
    @Mutation popRoute: PopRoute;
    @Mutation replaceRoute: ReplaceRoute;
    @Mutation setPage: Function;
    @Action addBooking: Function;
    done: boolean | null = null;


    async mounted() {
        try {
          await this.addBooking();
          this.done = true;
          setTimeout(() => {
              this.$router.replace('/user-admin');
          }, 3000);
        } catch (e) {
          this.done = false;
          setTimeout(() => {
              this.$router.replace('/user-admin');
          }, 3000);

        }
        this.replaceRoute(['Booking', 'Reserve', 'Create Package', 'Information', 'Overview', 'Completed']);
        this.setPage(5);
    }
    /**
     *
     */
    constructor() {
        super();

    }

    private get now(): any {
        return new Date().toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    }

    beforeDestroy(): void {
        this.popRoute();
    }
}
